(ns minorodata.components.connections.extract-pipeline-preview
  (:require
   ["@xyflow/react" :refer [ReactFlowProvider]]
   ["react" :as react]
   ["lucide-react" :refer [GitGraph Share2]]
   [minorodata.app.handlers :refer [dispatch]]
   [minorodata.app.utils :refer [get-dag-id]]
   [minorodata.components.pipeline-editor.dag :as pipeline-dag]
   [minorodata.components.pipeline-editor.utils :refer [features-context]]
   [minorodata.components.spinner.core :refer [spinner-lucide]]
   [re-posh.core :as re-posh]
   [ui.button :refer [button]]
   [ui.typography :as typography]))

(defn fetch-extract-dag [master-id filters]
  (dispatch [:pipeline-editor.events/set-dag-filter
             {:params (merge {:id (get-dag-id master-id false)}
                             filters)}]))

(defn extract-node-id [dag-data extract-id]
  (some (fn [{:keys [id data]}]
          (when (or (= id extract-id)
                    (= (get-in data [:metadata :extract-id]) extract-id))
            id))
        (:nodes dag-data)))

(defn go-to-pipelines [focus-id]
  (dispatch [:app.events/navigate :dag nil {:focus focus-id}]))

(defn go-to-pipeline-editor [{:keys [master-id source-id name]}]
  (dispatch [:pipeline-editor.events/navigate-and-open-tab
             {:id       master-id
              :group-id source-id
              :type     "extract"
              :name     name}]))

(defn pipeline-preview [{:keys [extract]}]
  (let [master-id       (:extract/master-id extract)
        extract-id      (:extract/extract-id extract)
        source-id       (:extract/source-id extract)
        extract-name    (:extract/name extract)
        features        @(re-posh/subscribe [:pipeline-editor.subs/features])
        dag-data        @(re-posh/subscribe [:pipeline-editor.subs/dag master-id :extract false])
        focus-id        (or (extract-node-id dag-data extract-id)
                            (extract-node-id dag-data master-id)
                            master-id)
        loading?        (or @(re-posh/subscribe [:mold-http/loading? :sandbox.api/fetch-live-dag])
                            @(re-posh/subscribe [:mold-http/loading? :dag.api/fetch-graph])
                            @(re-posh/subscribe [:mold-http/loading? :dag.api/load-dag-metadata]))]

    (react/useEffect
     (fn []
       (when master-id
         (dispatch [:sandbox.events/fetch-and-layout-dag
                    {:anchor-id   master-id
                     :anchor-type "extract"
                     :sandbox?    false}]))
       js/undefined)
     #js [master-id])

    [:section
     [:div {:class "mb-2 flex items-center justify-between gap-3"}
      [typography/h3 "Pipeline preview"]

      (when (seq (:nodes dag-data))
        [:div {:class "flex items-center gap-2"}
         [:span {:class "text-sm text-kleene-text-secondary"} "Open in:"]
         [button {:variant  :secondary
                  :size     :small
                  :icon     Share2
                  :on-click #(go-to-pipelines focus-id)}
          "Pipelines"]
         [button {:variant  :secondary
                  :size     :small
                  :icon     GitGraph
                  :on-click #(go-to-pipeline-editor
                              {:master-id master-id
                               :source-id source-id
                               :name      extract-name})}
          "Pipeline editor"]])]

     [:div {:class "h-[180px] overflow-hidden rounded-xs border bg-kleene-background-secondary"}
      (cond
        loading?
        [:div {:class "flex h-full items-center justify-center gap-2 text-kleene-text-secondary"}
         [spinner-lucide]
         "Loading pipeline preview..."]

        (seq (:nodes dag-data))
        [:> features-context.Provider
         {:value #js {:features   features
                      :read-only? true
                      :enabled    (fn [f]
                                    (get features (keyword f) false))}}
         [:> ReactFlowProvider
          [:div {:class "relative h-full"}
           [:f> pipeline-dag/subdag
            {:dag-data       dag-data
             :apply-filters  #(fetch-extract-dag master-id %)
             :show-controls? false
             :show-zoom?     false}]]]]

        :else
        [:div {:class "flex h-full items-center justify-center text-kleene-text-secondary"}
         "No pipeline preview available"])]]))
